module.exports = "/assets/data/40cfda8c9649a4abdce88d600921d9c7-EC1A.data.json";